import React from 'react';
import { string } from 'prop-types';

import {
  Container,
  TabMenu,
} from './styles';

import OverviewComponent from './overview';
import TaskSuccess from './tasks-success';
import FirstClick from './first-click';
import ParticipantPaths from './participant-paths';

const TAB_NAME = {
  overview: 'Overview',
  taskSuccess: 'Task Success',
  firstClick: 'First Click',
  participantPaths: 'Participant Paths',
};

const TreeTestAnalytics = (props) => {
  const {
    projectId,
    segmentId,
    projectTestType,
  } = props;

  const TAB_ITEMS = [
    {
      menuItem: TAB_NAME.overview,
      render: () => (
        <OverviewComponent
          projectId={projectId}
          segmentId={segmentId}
        />
      ),
    },
    {
      menuItem: TAB_NAME.taskSuccess,
      render: () => (
        <TaskSuccess
          projectId={projectId}
          segmentId={segmentId}
          projectTestType={projectTestType}
        />
      ),
    },
    {
      menuItem: TAB_NAME.firstClick,
      render: () => (
        <FirstClick
          projectId={projectId}
          segmentId={segmentId}
        />
      ),
    },
    {
      menuItem: TAB_NAME.participantPaths,
      render: () => (
        <ParticipantPaths
          projectId={projectId}
          segmentId={segmentId}
        />
      ),
    },
  ];

  return (
    <Container>
      <TabMenu menu={{ secondary: true }} panes={TAB_ITEMS} defaultActiveIndex={0} />
    </Container>
  );
};

TreeTestAnalytics.propTypes = {
  projectId: string.isRequired,
  segmentId: string,
  projectTestType: string.isRequired,
};

TreeTestAnalytics.defaultProps = {
  segmentId: undefined,
};

export default TreeTestAnalytics;
